import {BlockMath, InlineMath} from "react-katex";

const UnsupervisedLearningIntro = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">
        <h1 className="tw-header font-bold text-gray-900 mb-4">Unsupervised Learning</h1>
            <p className="text-gray-600 tw-subtitle text-justify">
                Unsupervised learning is like being a detective with no case file - you have to figure out
                what's interesting about the data without anyone telling you what to look for. It's the art
                of finding hidden patterns, secret clusters, and mysterious structures in data that has no labels.
            </p>
            <hr className="mt-2 mb-2"/>
            <p className="tw-subtitle text-gray-600">
                You are scrolling through a news article. You scroll to the bottom of the article, as let's be honest,
                you couldn't care less and just wanted something to pass your time with. Once you reach the bottom of
                the article, you realize that the suggested items are very similar to the one you just read.
                <br/>
                <br/>
                How come? The answer lies in clustering algorithms like K-means, which groups similar articles together
                using distance metrics:
            </p>
            <BlockMath math="d(x_i, x_j) = \sqrt{\sum_{k=1}^{n}(x_{ik} - x_{jk})^2}"/>
            <p className="tw-subtitle text-gray-600">
                The algorithm finds clusters by minimizing the within-cluster sum of squares:
            </p>
            <BlockMath math="WCSS = \sum_{i=1}^{k}\sum_{x \in C_i} ||x - \mu_i||^2"/>
            <p className="tw-subtitle text-gray-600">
                Where <InlineMath math="\mu_i"/> is the centroid of cluster <InlineMath math="C_i"/>.
                Other techniques include <strong>dimensionality reduction</strong> (making complex data simpler),
                <strong>association rules</strong> (finding "people who buy X also buy Y" patterns), and
                <strong>anomaly detection</strong> (spotting the weird stuff). It's like having a super-powered
                pattern recognition system that never gets tired of looking for connections!
            </p>
        </div>
    )
}

export default UnsupervisedLearningIntro;